const menuInit = () => {
  const navMenu = document.getElementById('js-aside')
  const navToggle = document.getElementById('js-aside-toggle')

  navToggle.addEventListener('click', () => {
    const navOpened = navToggle.getAttribute('aria-expanded')

    if (navOpened === 'false') {
      navToggle.setAttribute('aria-expanded', true)
      navMenu.setAttribute('aria-disabled', false)
    } else {
      navToggle.setAttribute('aria-expanded', false)
      navMenu.setAttribute('aria-disabled', true)
    }
  })
}

export default menuInit
